<template>
  <div class="flex flex-col">
    {{ $e("Remise à zéro de la gimbal") }} :
    <div class="flex flex-wrap">
      <button @click="resetGimbal(0)" class="btn">{{ $e("Recenter la gimbal") }}</button>
      <button @click="resetGimbal(1)" class="btn">{{ $e("Gimbal vers le bas") }}</button>
      <button @click="resetGimbal(2)" class="btn">{{ $e("Recenter la gimbal pan") }}</button>
      <button @click="resetGimbal(3)" class="btn">{{ $e("Gimbal pitch down") }}</button>
    </div>
  </div>
</template>
<script>
import API from "@/utils/API.js";
export default {
  name: "GimbalReset",
  props: {
    config: Object,
    video: Object,
  },
  setup() {
    return {
    };
  },

  mounted() {

  },

  methods: {
    async resetGimbal(type) {
      let data = await API.put(`gimbalreset`, {
        DevId: this.config.deviceFamilly.this_dev_id,
        CamId: this.config.camera.payload_index,
        Mode: type
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: this.$e("Remise à zéro de la gimbal"),
      };
    }
  },
};
</script>
